import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=0b37a20c&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=0b37a20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37a20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b37a20c')) {
      api.createRecord('0b37a20c', component.options)
    } else {
      api.reload('0b37a20c', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=0b37a20c&scoped=true&", function () {
      api.rerender('0b37a20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Customers/Chat.vue"
export default component.exports